// Scope predicates shared between the notice and the surfaces that react to it.
// Separate from ReportScopeNotice.tsx so that file exports only its component
// (react-refresh/only-export-components).

import type { DatasetManifestEntry } from '../../types/reporting';

/**
 * True when this caller may read no clinic's rows at all, so the report is
 * empty for a reason that has nothing to do with their filters.
 *
 * Callers use this to suppress an empty-state message that would misattribute
 * the cause. "No results match your filters" invites the reader to widen the
 * filters, which cannot work and wastes their time on a door that is locked.
 *
 * Deliberately narrow: an agency-wide caller, and a caller whose server sent
 * no scope at all, are both `false`. For them "nothing matched" is the true
 * and useful answer, and suppressing it would hide a real result.
 */
export const hasNoClinicAccess = (
  dataset: DatasetManifestEntry | null
): boolean =>
  dataset?.clinic_scope?.kind === 'clinics' &&
  dataset.clinic_scope.clinic_names.length === 0;
